<section class="d-flex flex-column justify-content-center align-items-center">

  <div class="form-floating has-validation" [class.w-25]="!isMobile()">
    <input class="form-control" [(ngModel)]="quantityModel" id="txtQuantity" appNumberRestriction
      placeholder="Quantity" />
    <label>Quantity</label>
  </div>

</section>

<footer class="modal-action-row has-btn-2">
  <button type="button" class="btn btn-outline-primary" (click)="cancel()">
    Discard Changes
  </button>
  <button type="button" class="btn btn-primary" (click)="confirm()">
    Confirm
  </button>
</footer>